// Real-money Gem packs. The prices and the catalog live in the Worker (server/src/index.js CATALOG);
// these are the amounts the client credits and the custom-amount rates, which the Worker mirrors.
// Keep the two in sync: a SKU the client can't credit stays pending until a build that can.

/** Fixed packs: Gems per pack, by price in EUR cents (for display order and bonus labels). */
export const GEM_PACKS: ReadonlyArray<{ gems: number; priceMinor: number; name?: string }> = [
  { gems: 100, priceMinor: 99 },
  { gems: 550, priceMinor: 499 },
  { gems: 1_200, priceMinor: 999 },
  { gems: 2_500, priceMinor: 1_999 },
  { gems: 6_500, priceMinor: 4_999 },
  { gems: 14_000, priceMinor: 9_999 },
  { gems: 37_500, priceMinor: 25_000, name: 'Gem Crate' },
  { gems: 77_500, priceMinor: 50_000, name: 'Gem Vault' },
  { gems: 160_000, priceMinor: 100_000, name: 'Gem Treasury' },
  { gems: 330_000, priceMinor: 200_000, name: 'Royal Treasury' },
];

/**
 * Custom pack (whole euros, EUR 2-2,500): the Gems-per-euro rate of the biggest fixed pack at or
 * below the amount, so a custom amount never beats the fixed packs.
 */
export const CUSTOM_GEMS = {
  minEur: 2,
  maxEur: 2_500,
  bands: [[2, 101], [5, 110], [10, 120], [20, 125], [50, 130], [100, 140], [250, 150], [500, 155], [1_000, 160], [2_000, 165]] as const,
};

/** Gems for a custom amount in whole euros, or null outside the range. */
export function customGems(eur: number): number | null {
  if (!Number.isInteger(eur) || eur < CUSTOM_GEMS.minEur || eur > CUSTOM_GEMS.maxEur) return null;
  let rate = CUSTOM_GEMS.bands[0][1] as number;
  for (const [from, r] of CUSTOM_GEMS.bands) if (eur >= from) rate = r;
  return Math.floor(eur * rate);
}
